import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type {
  BackendMutationDeleteVariationRatingsArgs,
  BackendVariationRating,
} from 'src/types/backend';

const MUTATION = gql`
  mutation DeleteVariationRatings($projectId: ID!, $generationTool: GenerationToolEnum!) {
    deleteVariationRatings(projectId: $projectId, generationTool: $generationTool) {
      id
    }
  }
`;

type Variables = BackendMutationDeleteVariationRatingsArgs;
type Result = Pick<BackendVariationRating, 'id'>[];

export const deleteVariationRatings = async (variables: Variables) => {
  const result = await executeGqlMutation({ mutation: MUTATION, variables });
  return getSingleProp<Result>(result.data);
};
